module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 9.f4383814.wav";